<template>
  <font-awesome-icon icon="fa-solid fa-circle-notch" spin size="5x" />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
